module.exports = __webpack_public_path__ + "static/cliente_8-97c5ebade1d27528354f206514f6aefc.png";